import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class WhatsappTemplateFileService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.WHATSAPP_TEMPLATE_FILE = "/api/whatsapp-template-file"

        this.GET_LIST_BY_LEADS_ID = "/list/leads/{leadsId}";
        this.ADD_NEW_FILE_FOR_TEMPLATE = "/add/file";
    }

    async getTemplateFileListByLeadsId(leadsId) {
        try {
            let url = window.location.origin + this.WHATSAPP_TEMPLATE_FILE + this.GET_LIST_BY_LEADS_ID;
            url = url
                .replace('{leadsId}', leadsId);
            const fileList = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return fileList;
        } catch(err) {
            console.log(err);
        }
    }

    async addNewFileForTemplate(bodyStr){
        try {
            let url = window.location.origin + this.WHATSAPP_TEMPLATE_FILE + this.ADD_NEW_FILE_FOR_TEMPLATE;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            const uploadNewFile = this.fetch(url,{
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(bodyStr)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return uploadNewFile;
        }
        catch(err){
            console.log(err);
        }
    };
}

export default WhatsappTemplateFileService;
